module.exports = __webpack_public_path__ + "img/tooth-root-canal.98a38318.svg";